import {
  ThreeStars,
  ShoppingBag,
  Controller,
  GraduationHat,
  RedCross,
  IndustrialPlant,
} from './icons';

export const typeFilters = {
  'tien-ich': [
    {
      id: 'kcn',
      icon: ThreeStars,
      label: 'Industrial Parks',
    },
    { id: 'truong-hoc', icon: GraduationHat, label: 'Schools' },
    { id: 'benh-vien', icon: RedCross, label: 'Hospitals' },
    {
      id: 'mall',
      icon: ShoppingBag,
      label: 'Shopping Malls',
    },
    { id: 'ben-xe', icon: Controller, label: 'Bus stations' },
    { id: 'airport', icon: IndustrialPlant, label: 'Airports' },
  ],
  'giao-thong': [
    {
      id: 'truc-duong-chinh',
      icon: ThreeStars,
      label: 'Main roads',
    },
    {
      id: 'truc-duong-phu',
      icon: ThreeStars,
      label: 'Urban roads',
    },
    { id: 'duong-mau-trang', icon: ThreeStars, label: 'Secondary roads' },
    { id: 'duong-song', icon: ThreeStars, label: 'Waterways' },
  ],
};

export const types = [
  {
    id: 'tien-ich',
    label: 'All amenities',
    labelShort: 'Amenities',
  },
  {
    id: 'giao-thong',
    label: 'All transport',
    labelShort: 'Transport',
  },
];
